// -------------------------------------------------------------------- constants --------------------------------------------------------------------
import Types from "routes/General/Types";
// ********************************************************************* devices *********************************************************************
const SET_FEED_DEVICE_SEARCH_VALUE = "SET_FEED_DEVICE_SEARCH_VALUE@FEED/DEVICE";
const INDEX_FEED_DEVICES_SUCCESS = "INDEX_FEED_DEVICES_SUCCESS";
const SHOW_FEED_DEVICE_SUCCESS = "SHOW_FEED_DEVICE_SUCCESS";
const STORE_FEED_DEVICE_SUCCESS = "STORE_FEED_DEVICE_SUCCESS";
const UPDATE_FEED_DEVICE_SUCCESS = "UPDATE_FEED_DEVICE_SUCCESS";
const DESTROY_FEED_DEVICE_SUCCESS = "DESTROY_FEED_DEVICE_SUCCESS";
// ***************************************************************** device reasons ******************************************************************
const STORE_FEED_DEVICE_REASON_SUCCESS = "STORE_FEED_DEVICE_REASON_SUCCESS";
const DESTROY_FEED_DEVICE_REASON_SUCCESS = "DESTROY_FEED_DEVICE_REASON_SUCCESS";
// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// ********************************************************************* devices *********************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _indexSuccess(payload) {
  return {
    type: INDEX_FEED_DEVICES_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showSuccess(payload) {
  return {
    type: SHOW_FEED_DEVICE_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _storeSuccess(payload) {
  return {
    type: STORE_FEED_DEVICE_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _updateSuccess(payload) {
  return {
    type: UPDATE_FEED_DEVICE_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {Number} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _destroySuccess(payload) {
  return {
    type: DESTROY_FEED_DEVICE_SUCCESS,
    payload: payload,
  };
}

// ***************************************************************** device reasons ******************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _storeReasonSuccess(payload) {
  return {
    type: STORE_FEED_DEVICE_REASON_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {Number} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _destroyReasonSuccess(payload) {
  return {
    type: DESTROY_FEED_DEVICE_REASON_SUCCESS,
    payload: payload,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

// ********************************************************************* devices *********************************************************************

/**
 *
 * @param {String} [searchValue=""]
 * @return {{type: String, payload: String}}
 */
export function setSearchValue(searchValue = "") {
  return {
    type: SET_FEED_DEVICE_SEARCH_VALUE,
    payload: searchValue,
  };
}

/**
 *
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function index(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Device@index")) {
      let types = Types.items("FeedConsole.Device", false, () => true, false);

      let _params = params;
      // _params.filterGroups = params.filterGroups || [];
      // _params.filterGroups.push({
      //   filters:[{
      //     key: "type_id",
      //     value:types.pluck('id'),
      //     operator: "in"
      //   }]
      // });

      api
        .get("/feeding/devices", { params: _params })
        .then((res) => {
          dispatch(_indexSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          app.error(
            err,
            "routes.home.feed.device",
            ".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید",
            app.translate("routes.home.feed.device.Indexing Devices Failed")
          );
          callback(err);
        });
    }
  };
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptyDevices() {
  return _indexSuccess({ data: { devices: [] } });
}

/**
 *
 * @param {Number} device
 * @param {Object} params
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function show(device, params, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Device@index")) {
      api
        .get(`/feeding/devices/${device}`, { params })
        .then((res) => {
          dispatch(_showSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          app.error(
            err,
            "routes.home.feed.device",
            ".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید",
            app.translate("routes.home.feed.device.Indexing Device Failed")
          );
          callback(err);
        });
    }
  };
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptyDevice() {
  return _showSuccess({ data: { device: {} } });
}

/**
 *
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function store(data, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Device@store")) {
      let loader = app.loading(
        app.translate("routes.home.feed.device.Adding New Device")
      );

      api
        .post("/feeding/devices", { data: { device: data } })
        .then((res) => {
          dispatch(_storeSuccess(res));
          loader.hide(() =>
            app.message(
              app.translate(
                "routes.home.feed.device.New Device Added Successfully"
              )
            )
          );
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide(() =>
            app.error(
              err,
              "routes.home.feed.device",
              "خطا در ارسال اطلاعات",
              app.translate("routes.home.feed.device.Adding New Device Failed")
            )
          );
          callback(err);
        });
    }
  };
}

/**
 *
 * @param {Number} device
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function update(device, data, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Device@update")) {
      let loader = app.loading(
        app.translate("routes.home.feed.device.Updating device")
      );

      api
        .put(`/feeding/devices/${device}`, { data: { device: data } })
        .then((res) => {
          dispatch(_updateSuccess(res));
          loader.hide(() =>
            app.message(
              app.translate(
                "routes.home.feed.device.Device updated Successfully"
              )
            )
          );
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide(() =>
            app.error(
              err,
              "routes.home.feed.device",
              "عملیات بروزرسانی با شکست مواجه شد",
              app.translate("routes.home.feed.device.Updating Device Failed")
            )
          );
          callback(err);
        });
    }
  };
}

/**
 *
 * @param {Number} device
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function patch(device, data, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Device@update")) {
      const loader = app.loading(
        app.translate("routes.home.feed.device.Updating device")
      );

      api
        .put(`/feeding/devices/${device}`, { data: { device: data } })
        .then((res) => {
          dispatch(_updateSuccess(res));
          loader.hide(() =>
            app.message(
              app.translate(
                "routes.home.feed.device.Device updated Successfully"
              )
            )
          );
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide(() =>
            app.error(
              err,
              "routes.home.feed.device",
              "عملیات بروزرسانی با شکست مواجه شد",
              app.translate("routes.home.feed.device.Updating device failed")
            )
          );
          callback(err);
        });
    }
  };
}

/**
 *
 * @param {Number} device
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function destroy(device, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Device@update")) {
      let loader = app.loading(
        app.translate("routes.home.feed.device.Removing Device")
      );

      api
        .delete(`/feeding/devices/${device}`)
        .then((res) => {
          dispatch(_destroySuccess(device));
          loader.hide(() =>
            app.message(
              app.translate(
                "routes.home.feed.device.Device Removed Successfully"
              )
            )
          );
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide(() =>
            app.error(
              err,
              "routes.home.feed.device",
              "عملیات حذف با شکست مواجه شد",
              app.translate("routes.home.feed.device.Removing Device Failed")
            )
          );
          callback(err);
        });
    }
  };
}

// ***************************************************************** device reasons ******************************************************************
/**
 *
 * @param {Number} device
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function storeReason(device, data, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("ClockingReason@store")) {
      let loader = app.loading(
        app.translate("routes.home.feed.device.Adding Device Reason")
      );

      api
        .post(`/feeding/devices/${device}/reasons`, { data: { reason: data } })
        .then((res) => {
          dispatch(_storeReasonSuccess(data));
          dispatch(
            show(device, {
              includes: ["reasons"],
            })
          );
          loader.hide(() =>
            app.message(
              app.translate(
                "routes.home.feed.device.Device Reason Added Successfully"
              )
            )
          );
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide(() =>
            app.error(
              err,
              "routes.home.feed.device",
              "خطا در ارسال اطلاعات",
              app.translate(
                "routes.home.feed.device.Adding Device Reason Device Failed"
              )
            )
          );
          callback(err);
        });
    }
  };
}

/**
 *
 * @param {Number} reason
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function destroyReason(reason, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("ClockingReason@destroy")) {
      let loader = app.loading(
        app.translate("routes.home.feed.device.Removing Device Reason")
      );

      api
        .delete(`/feeding/devices/reasons/${reason}`)
        .then((res) => {
          dispatch(_destroyReasonSuccess(reason));
          loader.hide(() =>
            app.message(
              app.translate(
                "routes.home.feed.device.Device Reason Removed Successfully"
              )
            )
          );
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide(() =>
            app.error(
              err,
              "routes.home.feed.device",
              "عملیات حذف با شکست مواجه شد",
              app.translate(
                "routes.home.feed.device.Removing Device Reason Device Failed"
              )
            )
          );
          callback(err);
        });
    }
  };
}

// ****************************************************************** connections ********************************************************************
/**
 *
 * @param {Number} device - device id
 * @param {String} method
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function request(device, method, data, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .post(`/feeding/devices/${device}/connect/${method}`, { data })
      .then((res) => {
        if ("Device SDK not found".equals(res.message)) {
          app.message(
            app.translate("routes.home.feed.device.Device SDK not found"),
            "error"
          );

          return callback(res);
        }

        callback(undefined, res);
      })
      .catch((err) => {
        callback(err);
      });
  };
}

/**
 *
 * @param {Number} device - device id to test connection
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function testConnection(device, data = {}, callback = () => {}) {
  return request(device, "test", data, callback);
  // return (dispatch, gs, api) => {
  //   api.post(`/feeding/devices/${device}/connect/test`, { data })
  //     .then((res) => {
  //       callback(undefined, res);
  //     })
  //     .catch((err) => {
  //       callback(err);
  //     });
  // };
}

// **************************************************************** Provinces & Cities *********************************************************************

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {{devices: Object[], groups: Object[]}} state
 * @param {{type: String, payload: Object}} action
 * @return {{devices: Object[]}}
 */
export default function reducer(
  state = {
    devices: [],
    pagination: {},
    searchValue: "",
    device: {},
  },
  action
) {
  let devices;
  let device;
  let _index;
  let _meta;

  switch (action.type) {
    case SET_FEED_DEVICE_SEARCH_VALUE:
      return Object.assign({}, state, { searchValue: action.payload });
    case INDEX_FEED_DEVICES_SUCCESS:
      _meta = action.payload.meta;
      return Object.assign({}, state, {
        devices: action.payload.data.devices,
        pagination: _meta
          ? app.pagination(_meta.currentPage + 1, _meta.total, _meta.limit)
          : {},
      });
    case SHOW_FEED_DEVICE_SUCCESS:
      return Object.assign({}, state, {
        device: action.payload.device,
      });
    case STORE_FEED_DEVICE_SUCCESS:
      return Object.assign({}, state, {
        devices: [action.payload, ...state.devices],
      });
    case UPDATE_FEED_DEVICE_SUCCESS:
      devices = app._.cloneDeep(state.devices);
      _index = devices.findIndex((_device) => _device.id === action.payload.id);
      devices[_index] = action.payload;
      return Object.assign({}, state, {
        devices,
      });
    case DESTROY_FEED_DEVICE_SUCCESS:
      devices = app._.cloneDeep(state.devices);
      _index = devices.findIndex((_device) => _device.id === action.payload);
      devices.splice(_index, 1);
      return Object.assign({}, state, {
        devices,
      });
    case DESTROY_FEED_DEVICE_REASON_SUCCESS:
      device = app._.cloneDeep(state.device);
      _index = device.reasons.findIndex(
        (_reason) => _reason.id === action.payload
      );
      device.reasons.splice(_index, 1);
      return Object.assign({}, state, {
        device,
      });
    default:
      return state;
  }
}
